import React, { createContext, useContext, useState, ReactNode } from 'react';
import { TraceContextType } from '@/Models';

const TraceContext = createContext<TraceContextType | undefined>(undefined);

export const TraceContextProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [traceId] = useState<string>(() => crypto.randomUUID());

  return (
    <TraceContext.Provider value={{ traceId }}>
      {children}
    </TraceContext.Provider>
  );
};

export const useTraceContext = () => {
  const context = useContext(TraceContext);
  if (!context) {
    throw new Error('useTraceContext must be used within TraceContextProvider');
  }
  return context;
};
